// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenuButton-cls1__c3c5eba5086fbca935bf","cls2":"AccountMenuButton-cls2___388eb8ca16a10571e18 AccountMenuButton-cls1__c3c5eba5086fbca935bf"};